import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import ProductTabs from "../../../Componants/Common/product tabs/ProductTabs";
import config from "../../../Componants/Common/config";
import {
  Autocomplete,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CommonButton from "../../../Componants/Common/Button";
import InputFileUpload from "../../../Componants/Common/Bulk Upload/InputFileUpload";
import Template from "../../../Componants/Common/Bulk Upload/Template";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import ExportToExcel from "../../../Componants/Common/ExportToExcel";
import {
  createBrand,
  exportBrand,
  fetchBrandList,
  updateBrand,
  updateBrandStatus,
} from "../../../API Service/apiService";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../Componants/Loader/Loader";
import Paginate from "../../../Componants/Common/Paginate";

const cells = ["S.No", "Brand", "Description", "Action"];

const Managebrand = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const pageSize = config.pageSize;
  const [dataSize, setDataSize] = useState(pageSize);
  const [brandName, setBrandName] = useState("");
  const [description, setDescription] = useState("");
  const [tableData, setTableData] = useState([]);
  const [brandList, setBrandList] = useState([]); // Renamed for clarity
  const [postData, setPostData] = useState({ brandName: "", description: "" });
  const [editIndex, setEditIndex] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(null);
  const [brandError, setBrandError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const brandheader = [
    { label: "Brand", key: "brandName" },
    { label: "Description", key: "description" },
    { label: "Status", key: "active" },
  ];

  const [searchParams, setSearchParams] = useState({
    search: "",
    page: 1,
    limit: 10,
  });

  // New state for temporary search input
  const [searchInput, setSearchInput] = useState("");

  const handleCancel = () => {
    setBrandName("");
    setDescription("");
    setEditIndex(false);
    setBrandError(false);
    setDescriptionError(false);
  };

  const handleSearchCancel = async () => {
    const updatedParams = {
      ...searchParams,
      search: "",
      page: 1,
    };
    setSearchParams(updatedParams);
    setPage(1); // Reset page state to 1
    setSearchInput(""); // Clear temporary search input
    await getBrandList(updatedParams);
  };

  const getBrandList = async (params = searchParams) => {
    try {
      setLoading(true);
      console.log("Fetching brand list with params:", params);
      const response = await fetchBrandList(params);
      setTableData(response.data.brandList);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      console.error("Error fetching brand list:", error);
    } finally {
      setLoading(false);
    }
  };

  const getBrandDropdown = async () => {
    try {
      setLoading(true);
      const response = await fetchBrandList({ limit: 100 }); // Fetch more brands for dropdown if needed
      setBrandList(response.data.brandList);
    } catch (error) {
      console.error("Error fetching brand list for dropdown:", error);
    } finally {
      setLoading(false);
    }
  };

  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  useEffect(() => {
    const updatedParams = { ...searchParams, page };
    setSearchParams(updatedParams); // Update searchParams when page changes
    getBrandList(updatedParams);
    getBrandDropdown();
  }, [page]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePostRequest = async () => {
    let isValid = true;

    if (!brandName.trim()) {
      setBrandError(true);
      isValid = false;
    } else {
      setBrandError(false);
    }

    if (!description.trim()) {
      setDescriptionError(true);
      isValid = false;
    } else {
      setDescriptionError(false);
    }

    if (!isValid) {
      
      return;
    }

    try {
      setLoading(true);
      postData.brandName = brandName;
      postData.description = description;

      if (!editIndex) {
        const response = await createBrand(postData);
        toast.success(response.message);
      } else {
        const dataToUpdate = {
          brandId: editIndex,
          brandName: brandName,
          description: description,
        };
        const response = await updateBrand(dataToUpdate);
        toast.success(response.message);
        setEditIndex(false);
      }
      setBrandName("");
      setDescription("");
      getBrandList(searchParams);
      getBrandDropdown();
    } catch (error) {
      console.log(`Error saving Brand ${error}`);
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (brandId, brandName, description) => {
    setEditIndex(brandId);
    setBrandName(brandName);
    setDescription(description);
  };

  const handleStatus = async (index, brandId) => {
    try {
      setLoading(true);
      const response = await updateBrandStatus({ brandId: brandId });
      if (response.status === "success") {
        toast.success("Status Updated Successfully");
      }
      getBrandList(searchParams);
    } catch (error) {
      console.log(`Error updating status ${error}`);
      toast.error(`Failed to update status`);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    const updatedParams = {
      ...searchParams,
      search: searchInput,
      page: 1, // Reset to page 1 when searching
    };
    setSearchParams(updatedParams);
    setPage(1); // Also update the page state to 1
    try {
      setLoading(true);
      await getBrandList(updatedParams);
    } catch (error) {
      console.log(`Error in filter List: ${error}`);
      toast.error("Failed to Update List");
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      setLoading(true);
      const params ={
        search: searchParams.search
      }
      const response = await exportBrand(params);
      const blob = new Blob([response], { type: "application/vnd.ms-excel" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "brands.xlsx";
      document.body.appendChild(a);
      a.click();
      console.log(response);
    } catch (error) {
      console.log(`Error in export brand: ${error}`);
      toast.error("Failed to export brand");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container>
      {loading && <Loader />}
      <Toaster position="top-center" reverseOrder={false} />
      <HeaderNavigation value={"Product > Brand"}  location={"/setting"} />
      {/* Create Brand */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid item container>
          <ProductTabs selectedTab="one" />
        </Grid>

        <Grid container spacing={10}>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="brand-name"
              label="Brand Name"
              variant="standard"
              value={brandName}
              onChange={(e) => {
                setBrandName(e.target.value);
                setBrandError(false); // Clear error when typing
              }}
              required
              error={brandError}
              helperText={brandError ? "Brand Name is required." : ""}
            />
          </Grid>

          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="description"
              label="Description"
              variant="standard"
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                setDescriptionError(false); // Clear error when typing
              }}
              required
              error={descriptionError}
              helperText={descriptionError ? "Description is required." : ""}
            />
          </Grid>
        </Grid>
        <Grid container gap={2} spacing={5} sx={{ marginTop: "1rem" }}>
        <Grid item>
            <CommonButton
              name={editIndex === false ? "Save" : "Update"}
              handleOnClick={handlePostRequest}
            />
          </Grid>
          <Grid item>
            <CommonButton name={"Cancel"} handleOnClick={handleCancel} />
          </Grid>
          

          <Grid container></Grid>
        </Grid>
      </Grid>

      {/* Bulk Upload */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid container>
          {" "}
          <Typography variant="h6">Bulk Upload</Typography>
        </Grid>
        <Grid container gap={10}>
          <Grid item>
            <InputFileUpload />
          </Grid>
          <Grid item>
            <CommonButton name={"Upload"} />
          </Grid>
          <Grid item sx={{ padding: "1rem" }}>
            <Template label={"Download Template"} />
          </Grid>
          <Grid item sx={{ padding: "1rem" }}>
            <Template label={"Download Reference Code"} />
          </Grid>
        </Grid>
      </Grid>
      {/* Brand List */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid item container>
          <Typography variant="h6">List View</Typography>
        </Grid>
        <Grid container gap={5}>
          <Grid item sx={{ minWidth: "200px" }}>
            <Autocomplete
              id="disable-close-on-select"
              options={brandList}
              getOptionLabel={(option) => option?.brandName || ""}
              value={brandList.find((brand) => brand.brandName === searchInput) || null} // Use searchInput instead of searchParams.search
              onChange={(event, newValue) => {
                setSearchInput(newValue?.brandName || ""); // Update temporary search input, not searchParams
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Brand"
                  variant="standard"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item>
            <CommonButton name={"Search"} handleOnClick={handleSearch} />
          </Grid>
          <Grid item>
            <CommonButton name={"Cancel"} handleOnClick={handleSearchCancel} />
          </Grid>
        </Grid>

        <Grid container>
          <Grid container justifyContent="flex-end">
            <ExportToExcel
             onClick={handleExport}
            />
          </Grid>

          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  {cells.map((cell, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        color: "white",
                        textAlign:
                          index === cells.length - 1 ? "right" : "center",
                        paddingRight: index === cells.length - 1 ? "4rem" : "",
                      }}
                    >
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={cells.length} align="center">
                      No Data Available
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {(searchParams.page - 1) * searchParams.limit + index + 1}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row.brandName, 50)}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row.description, 50)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                        }}
                      >
                        <IconButton
                          onClick={() => handleStatus(index, row._id)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={
                              row.active === false ? inactiveIcon : activeIcon
                            }
                            alt="active"
                            height="20px"
                            width="20px"
                          />
                        </IconButton>

                        <IconButton
                          onClick={() =>
                            handleEdit(row._id, row.brandName, row.description)
                          }
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={editIcon}
                            alt="Edit"
                            height={"20px"}
                            width={"20px"}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <div
          className="pagination-container"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default Managebrand;